<template>
    <div>
        <div class="pv3 mid-gray bt bb b--light-gray ph3">
            <h6>Browse Tools & Equipment by project</h6>
        </div>
        <MenuItem  class="pr3" v-for="(project, index) in projects" :key="index" :title="project.title" :route="project.route"/>
    </div>
</template>

<script>
import MenuItem from '@/components/global/MenuItem.vue';

const PROJECTS = [
    {
        title: 'Basement',
        route: 'error-page'
    },
    {
        title: 'Bathroom',
        route: '/error-page'
    },
    {
        title: 'Doors & Windows',
        route: '/error-page'
    },
    {
        title: 'Electricity',
        route: '/error-page'
    }
];

export default {
    data: function() {
        return {
            projects: PROJECTS
        };
    },
    components: {
        MenuItem
    }
};
</script>
